import { FontIconName } from "client/Components";
import { ContactListItem } from "client/Api/Email/contacts";
import { useCommunicationActions } from "client/Features/AddressBook/useCommunicationActions";
import { generateTrackingId, isNotNil } from "client/Misc/utils";
import { ReactElement, useMemo } from "react";
import { ActionButton } from "./ActionButton";

export type CommunicationActionsProps = {
	contact: ContactListItem;
};

export const CommunicationActions = (props: CommunicationActionsProps): ReactElement => {
	const {
		contact
	} = props;

	const {
		sendEmail,
		makePhoneCall,
		startTeamsChat,
		startTeamsVideoCall
	} = useCommunicationActions(contact);

	const actions = useMemo(
		(): readonly ActionData[] => {
			return [
				{
					icon: "envelope",
					key: "send-email",
					handler: sendEmail
				},
				{
					icon: "phone",
					key: "make-phone-call",
					handler: makePhoneCall
				},
				{
					icon: "video",
					key: "start-teams-video-call",
					handler: startTeamsVideoCall
				},
				{
					icon: "comment",
					key: "start-teams-chat",
					handler: startTeamsChat
				}
			];
		},
		[
			makePhoneCall,
			sendEmail,
			startTeamsChat,
			startTeamsVideoCall
		]
	);

	return (
		<ActionList
			actions={actions}
		/>
	);
};
CommunicationActions.displayName = "CommunicationActions";

type ActionData = {
	key: string;
	icon: FontIconName;
	handler?(): void;
};

export type ActionListProps = {
	actions: readonly ActionData[];
};

export const ActionList = (props: ActionListProps): ReactElement => {
	const {
		actions
	} = props;

	const lastAvailableAction: ActionData | null = actions.reduce(
		(acc: ActionData | null, cur: ActionData): ActionData | null => {
			return cur.handler ? cur : acc;
		},
		null
	);

	return (
		<>
			{actions.map(a =>
				isNotNil(a.handler) && (
					<ActionButton
						key={a.key}
						icon={a.icon}
						onClick={a.handler}
						position={a === lastAvailableAction ? "last" : undefined}
						trackingId={generateTrackingId("action", `|${a.key}`)}
						shouldOnlyBeVisibleOnHover
					/>
				)
			)}
		</>
	);
};
ActionList.displayName = "ActionList";